import PresetActions from '../Redux/PresetRedux'
import { baseFetchNoToken, baseFetchToken } from './BaseSaga'
import { getToken } from '../Services/GetToken'

export function * getCurrencies (api, action) {
  yield baseFetchNoToken(
    api.getCurrencies,
    action,
    PresetActions.currencySuccess,
    PresetActions.currencyFailure
  )
}

export function * getLanguages (api, action) {
  yield baseFetchNoToken(
    api.getLanguages,
    action,
    PresetActions.languageSuccess,
    PresetActions.languageFailure
  )
}

export function * getCountries (api, action) {
  yield baseFetchNoToken(
    api.getCountries,
    action,
    PresetActions.countriesSuccess,
    PresetActions.countriesFailure
  )
}

export function * getPresetOrder (api, action) {
  yield baseFetchNoToken(
    api.getPresetOrder,
    action,
    PresetActions.presetOrderSuccess,
    PresetActions.presetOrderFailure
  )
}

export function * updatePresetOrder (api, action) {
  yield baseFetchToken(
    api.updatePresetOrder,
    action.data,
    getToken,
    PresetActions.presetOrderUpdateSuccess,
    PresetActions.presetOrderUpdateFailure
  )
}

export function * getBranch (api, action) {
  yield baseFetchToken(
    api.getBranch,
    action,
    getToken,
    PresetActions.getBranchSuccess,
    PresetActions.getBranchFailure
  )
}

export function * updateBranch (api, action) {
  yield baseFetchToken(
    api.updateBranch,
    action.data,
    getToken,
    PresetActions.updateBranchSuccess,
    PresetActions.updateBranchFailure
  )
}

export function * getShipping (api, action) {
  yield baseFetchNoToken(
    api.getShipping,
    action,
    PresetActions.getShippingSuccess,
    PresetActions.getShippingFailure
  )
}

export function * updateShipping (api, action) {
  yield baseFetchToken(
    api.updateShipping,
    action.data,
    getToken,
    PresetActions.updateShippingSuccess,
    PresetActions.updateShippingFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/PresetSagas.js